var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.can_access('fdrate','view'))?_c('div',{staticClass:"row"},[(_vm.show)?_c('div',[_c('FDRateForm',{attrs:{"formReRender":_vm.formReRender}})],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }